import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../../../../../core/pure-functions/rx-helper';
import { CometChatService } from '../../../../../core/services/cometChat/cometChat.service';

@Component({
  selector: 'app-owner-context',
  templateUrl: './owner.component.html',
})
export class OwnerContextComponent implements OnInit, OnDestroy {
  cometChatServiceProvider;
  subs: Subscription[] = [];

  constructor(private cometChatService: CometChatService) {}

  async ngOnInit() {
    await this.initContext();
  }

  ngOnDestroy() {
    unsubscribeFromAll(this.subs);
  }

  private async initContext(): Promise<void> {
    try {
      await this.cometChatService.login();
      this.cometChatServiceProvider = this.cometChatService;
    } catch (err) {
      console.error('Failed to initialize context:', err);
    }
  }
}
